<template>
	<div class="study_header career_header bg_white">
		<div class="w1200 flex">
			<div class="study_header_l">
				<img src="../../static/logo_colour.png" class="study_header_logo" />
				<div class="f20px study_header_name">·&nbsp;&nbsp;&nbsp;&nbsp;生涯规划</div>
			</div>
			<div class="career_header_r">
				<ul class="career_nav f18px cl_dark">
					<li class="career_nav_list" :class="{'on':careerNav==0}">
						<router-link to="/career" class="cl_dark career_nav_list_top">生涯测试</router-link>
					</li>
					<li class="career_nav_list" :class="{'on':careerNav==1}">
						<router-link to="/choice" class="cl_dark career_nav_list_top">3+2+1选科</router-link>
					</li>
					<li class="career_nav_list" :class="{'on':careerNav==2}">
						<router-link to="/treasury" class="cl_dark career_nav_list_top">生涯宝库</router-link>
						<ul class="career_nav_list_hide bg_white radius8 tc f16px">
							<li><router-link to="/treasury_major" class="block cl_dark">专业信息库</router-link></li>
							<li><router-link to="/treasury_career" class="block cl_dark">职业信息库</router-link></li>
							<li><router-link to="/treasury_un" class="block cl_dark">院校信息库</router-link></li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'career_header',
	  props: {
			careerNav: Number,
	  },
		data () {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {
			
		},
	}
</script>

<style>
</style>
